import EfCardSupport from '@elem/ui/ef-card-support';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { IPageStatus } from '../../../config/IPageStatus';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp({ pageStatus }: any) {
    const { t } = useLang('theProduct.SectionE');
    const { locale, pathname } = getLocal();

    return (
        <div className={styles.TheComp} id="section-SectionE">
            <EfSpec />
            {pageStatus === IPageStatus.statusC && <EfTitle>{t('title_1')}</EfTitle>}
            <EfCardSupport
                pc="https://websiteoss.ecoflow.com/upload/image/1723002700488/pc_trade_in.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1723002689389/m_trade_in.jpg"
                title={t('title')}
                desc={t.rich('desc', {
                    strong: (text: string) => <span className="big">{text}</span>,
                })}
                moreLink={`https://${locale}.ecoflow.com/pages/trade-in`}
                moreText={t('btn')}
                dataLayer={[
                    {
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: pathname,
                        list_name: t('title'),
                        button_name: t('btn'),
                        function: 'Release commemoration campaign',
                    },
                ]}
            />
            <div className="SectionE-desc">{t('tips')}</div>
        </div>
    );
}
